enum TextFieldActionType {
    DISPLAY_TEXT_FIELD_ERROR = "DISPLAY_TEXT_FIELD_ERROR",
    UPDATE_TEXT_FIELD_VALUE = "UPDATE_TEXT_FIELD_VALUE",
    RESET_TEXT_FIELD = "RESET_TEXT_FIELD",
}

export default TextFieldActionType;
